import { CarvanaTheme as ShowroomTheme } from '@carvana/showroom-theme';
import { breakpoints } from '@carvana/stc-styles';
import { CarvanaTheme } from '@carvana/theme';

import palette from './palette';
import spacing from './spacing';
import typography from './typography';

export const theme = {
  ...ShowroomTheme,
  palette: {
    primary: {
      main: palette.carvanaBlue,
      dark: palette.darkBlue1,
      contrastText: palette.white
    },
    secondary: {
      main: palette.carvanaYellow
    }
  },
  v2: {
    palette,
    typography,
    breakpoints
  },
  carvana: {
    ...CarvanaTheme.carvana,
    gray: { ...CarvanaTheme.carvana.gray, lightest: '#f1f7fa' },
    dealerMarketplace: {
      purple: '#5c3fe1'
    }
  },
  typography: {
    fontFamily: CarvanaTheme.typography.fontFamily,
    fontSize: 16,
    useNextVariants: true
  },
  spacing,
  breakpoints
};

export default theme;
